const settings = (axios) => {
  return {
    errorConfiguration: {
      /**
       * @method get
       * @api /api/errorcategory/
       */
      get() {
        return axios.get('/errorcategory')
          .then((response) => response);
      },

      /**
       * @param params
       * @method post
       * @api /api/error_category/create/
       */
      create(params) {
        return axios.post('/error_category/create/', params)
          .then((response) => response);
      },

      /**
       * @param params
       * @method post
       * @api /api/error_category/update/
       */
      update(params) {
        return axios.post('/error_category/update/', params)
          .then((response) => response);
      },

      /**
       * @param id
       * @method post
       * @api /api/error_category/deactivate/
       */
      disable(id) {
        return axios.post(`/error_category/deactivate/${id}`)
          .then((response) => response);
      },

      /**
       * @param id
       * @method post
       * @api /api/error_category/set_as_deleted/
       */
      delete(id) {
        return axios.post(`/error_category/set_as_deleted/${id}`)
          .then((response) => response);
      },

    },

    formattingConfiguration: {

      /**
       * @param params
       * @method post
       * @api /api/updateOptions/
       */
      update(params) {
        return axios.post('/updateOptions/', params)
          .then((response) => response);
      },
    },

    metricsConfiguration: {

      /**
       * Method for getting all metrics
       * for configuration page
       */
      get() {
        return axios.get('/metric')
          .then((response) => response);
      },

      /**
       * Method for deleting metric
       * @param {Number} metricId - metric id
       */
      delete(metricId) {
        return axios.post(`/metrics/set_deleted/${metricId}`)
          .then((response) => response);
      },

      getErrorCategoriesForMetric(metricId) {
        return axios.get(`error_category/forMetric/${metricId}`)
          .then((response) => response);
      },

      getAllErrorCategories() {
        return axios.get('error_category/forMetric')
          .then((response) => response);
      },

      getEditData(metricId) {
        return axios.get(`/metrics/get_edit_data/${metricId}`)
          .then((response) => response);
      },

      createMetric(params) {
        return axios.post('/metrics/create', params)
          .then((response) => response);
      },
      updateMetric(params) {
        return axios.post('/metrics/update', params)
          .then((response) => response);
      },
    },

    workflowsConfiguration: {
      getAllSteps() {
        return axios('/workflowSteps/get')
          .then((response) => response);
      },

      addStep(step) {
        return axios.post('/workflowSteps/save', step)
          .then((res) => res);
      },

      editStep(step) {
        return axios.post('/workflowSteps/edit', step)
          .then((res) => res);
      },

      removeStep(id) {
        return axios.post(`/workflowSteps/remove/${id}`)
          .then((res) => res);
      },
    },

    superordinate: {
      list: () => axios.get('/metarule'),
      create: (params) => axios.post('/metarules/create', params),
      update: (params) => axios.post('/metarules/update', params),
      delete: (id) => axios.post(`/metarules/set_as_deleted/${id}`),
    },

    languageConfiguration: {
      getLanguages: (page = 1, perPage = 12, sortDir = 'ASC', query = '') => {
        const url = `/lang/getlist?page=${page}&ppage=${perPage}&sortDirection=${sortDir}&query=${query}`;
        return axios.get(url);
      },
      getLanguageCombinations: (page = 1, perPage = 12, sortDir = 'ASC', sortField = 'target', query = '') => {
        const url = `/lang_combinations/get?page=${page}&ppage=${perPage}&sortDirection=${sortDir}&sortField=${sortField}&query=${query}`;
        return axios.get(url);
      },
      editLanguage: (options) => {
        const url = '/lang/update';
        return axios.post(url, options);
      },
      removeLanguage: (id) => {
        const url = `/lang/delete/${id}`;
        return axios.post(url);
      },
      createLanguage: (language) => {
        const url = '/lang/create';
        return axios.post(url, language);
      },
      restoreLanguage: (id) => {
        const url = `/lang/restore/${id}`;
        return axios.post(url);
      },
    },

    notifications: {
      getNotifications: () => {
        const url = '/notification';
        return axios.get(url);
      },
      addNotification: (notification) => {
        const url = '/notification/add';
        return axios.post(url, notification);
      },
      removeNotification: (notification) => {
        const url = '/notification/remove';
        return axios.post(url, notification);
      },
      updateNotification: (notification) => {
        const url = '/notification/update';
        return axios.post(url, notification);
      },
    },
  };
};

export default settings;
